import { useRef, useState, useEffect, useCallback } from "react";

// Arraste de cards por toque (mobile): segurar (long-press) para "pegar" o card,
// arrastar sobre outra coluna e soltar. Detecta a coluna por [data-col-key].
// Não interfere no scroll: só ativa após ~250ms segurando parado; se o dedo
// deslizar antes disso, entende como rolagem e cancela.
export function useKanbanTouchDrag(onDrop) {
  const [drag, setDrag] = useState(null); // { item, x, y, label, over }
  const st = useRef({ item: null, timer: null, startX: 0, startY: 0, active: false, colKey: null });

  const clearTimer = () => { if (st.current.timer) { clearTimeout(st.current.timer); st.current.timer = null; } };

  const start = useCallback((e, item, label) => {
    if (!e.touches || e.touches.length !== 1) return;
    const t = e.touches[0];
    st.current.item = item; st.current.startX = t.clientX; st.current.startY = t.clientY;
    st.current.active = false; st.current.colKey = null;
    clearTimer();
    st.current.timer = setTimeout(() => {
      st.current.active = true;
      if (navigator.vibrate) { try { navigator.vibrate(18); } catch (_) {} }
      setDrag({ item, x: st.current.startX, y: st.current.startY, label, over: null });
    }, 250);
  }, []);

  useEffect(() => {
    const move = (e) => {
      if (!st.current.item) return;
      const t = e.touches[0];
      if (!st.current.active) {
        if (Math.abs(t.clientX - st.current.startX) > 8 || Math.abs(t.clientY - st.current.startY) > 8) {
          clearTimer(); st.current.item = null;
        }
        return;
      }
      e.preventDefault(); // segura a rolagem enquanto arrasta
      const el = document.elementFromPoint(t.clientX, t.clientY);
      const col = el && el.closest("[data-col-key]");
      st.current.colKey = col ? col.getAttribute("data-col-key") : null;
      setDrag((d) => (d ? { ...d, x: t.clientX, y: t.clientY, over: st.current.colKey } : d));
    };
    const end = (e) => {
      clearTimer();
      if (st.current.active) {
        if (e.cancelable) e.preventDefault(); // evita o "click" fantasma após arrastar
        if (st.current.item && st.current.colKey) onDrop(st.current.item, st.current.colKey);
      }
      st.current.item = null; st.current.active = false; st.current.colKey = null;
      setDrag(null);
    };
    window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("touchend", end, { passive: false });
    window.addEventListener("touchcancel", end, { passive: false });
    return () => {
      window.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", end);
      window.removeEventListener("touchcancel", end);
    };
  }, [onDrop]);

  return { drag, start };
}

export function DragGhost({ drag }) {
  if (!drag) return null;
  return (
    <div
      style={{ position: "fixed", left: drag.x, top: drag.y, transform: "translate(-50%, -60%)", pointerEvents: "none", zIndex: 70, width: 220 }}
      className="rounded-lg bg-[#111622] border-2 border-[#0CDBF2] px-3 py-2 shadow-2xl shadow-black/60 text-sm font-medium text-white opacity-95">
      {drag.label}
    </div>
  );
}
